import { getMapZoomInteger } from 'features/mapping/mapping.utils';
import { useState } from 'react';
import { useMapInstance } from 'shared/map-exports';
import { useMapEvent } from 'features/mapping/hooks/useMapEvent';

export const useMapZoomInteger = (): number | undefined => {
  const map = useMapInstance();
  const [zoom, setZoom] = useState<number | undefined>();

  useMapEvent(
    'zoomend',
    () => {
      setZoom(getMapZoomInteger(map));
    },
    map,
    true,
  );

  return zoom;
};
